import { ISchema, Schema, forEachSchemaNode } from '@framework/validation';

/**
 * Esporta i valori di un modulo in base alla direttiva `tableSave` dei campi.
 */
export function exportTableSaveDirective(
  schema: ISchema<any>,
  options: { value: any; context?: any },
) {
  const tableValues: Record<string, any | any[]> = {};

  forEachSchemaNode(schema, options, node => {
    if (
      node.schema instanceof Schema &&
      node.schema.meta?.()?.directiveTableSave
    ) {
      const tableSaveFieldName = node.schema.meta?.()?.directiveTableSave as
        | string
        | null;
      if (!tableSaveFieldName) return;

      const isArray = node.inArrayPath != null;

      if (isArray) {
        // Se siamo in un array, provvediamo ad esportare i valori in un array.
        // Ad esempio se ho un campo `lista_uffici.0.id_ufficio` con valore 123,
        // il risultato sarà:
        //  lista_uffici: [123]
        if (!Array.isArray(tableValues[tableSaveFieldName])) {
          tableValues[tableSaveFieldName] = [];
        }
        tableValues[tableSaveFieldName].push(node.value);
      } else {
        // Se non siamo in un array, esportiamo il valore direttamente
        tableValues[tableSaveFieldName] = node.value;
      }
    }
  });

  return tableValues;
}
